const INCLUDES = [
  { icon: 'ri-stack-line', label: 'Металл и материалы', desc: 'Сталь, пруток, лист. Жаростойкое покрытие. Деревянные или кожаные рукояти на выбор' },
  { icon: 'ri-layout-5-line', label: 'Изготовление', desc: 'Ковка, сварка, зачистка, сборка. Ручная работа мастера с контролем каждой детали' },
  { icon: 'ri-paint-brush-line', label: 'Покраска', desc: 'Термостойкое покрытие, устойчивое к высоким температурам и саже. Цвет RAL на выбор' },
  { icon: 'ri-truck-line', label: 'Доставка', desc: 'Бережная упаковка и транспортировка готового набора до вашего дома' },
  { icon: 'ri-tools-fill', label: 'Установка', desc: 'Размещение набора у камина, фиксация подставки, финальная проверка комплектации' },
];

const DURABILITY = [
  {
    icon: 'ri-hard-drive-2-line',
    title: 'Прочный металл',
    desc: 'Сталь толщиной от&nbsp;3&nbsp;мм в&nbsp;рабочих элементах. Кочерга и&nbsp;щипцы выдерживают интенсивное использование без&nbsp;деформации.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Жаростойкость',
    desc: 'Специальное термостойкое покрытие выдерживает температуры до&nbsp;600°C. Инструменты не&nbsp;нагреваются через&nbsp;рукоять.',
  },
  {
    icon: 'ri-shield-flash-line',
    title: 'Антикоррозийная защита',
    desc: 'Двухэтапная обработка металла: цинковый грунт и&nbsp;термостойкое финишное покрытие. Защита от&nbsp;влаги и&nbsp;сажи.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Качественная покраска',
    desc: 'Порошковая покраска по&nbsp;каталогу RAL. Не&nbsp;отслаивается от&nbsp;перепадов температур, не&nbsp;выгорает, устойчива к&nbsp;истиранию.',
  },
];

export default function WhySection() {
  return (
    <>
      {/* What's included */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Что входит в стоимость
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Прозрачная комплектация — вы точно знаете, из&nbsp;чего складывается&nbsp;цена
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {INCLUDES.map((item, idx) => (
              <div
                key={item.label}
                className="text-center group animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-400">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5">{item.label}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Durability */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Почему набор прослужит долго
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Четыре причины, по которым каминный набор остаётся надёжным и&nbsp;красивым десятилетиями
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {DURABILITY.map((item, idx) => (
              <div
                key={item.title}
                className="flex items-start gap-5 bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-7 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}